<div>
    <div
        class="container-fluid"
        style="text-align: left"
    >
        <div
            class="badge-legend cmps-cdk-px-0"
            [ngClass]="{ 'row-is-expanded': rowExpanded === true }"
        >
            <div class="utilities-buttons">
                <cmps-coaching-filter
                    (filterToggled)="filterToggledHandler($event)"
                    (filterApplied)="handleFiltered($event)"
                    (toggledDisplay)="toggledDisplay.emit($event)"
                >
                    <cmps-icon svgIcon="cog-outline"></cmps-icon>
                </cmps-coaching-filter>

                <!-- filter performers and their opps -->
                <button
                    (click)="showDefaultView()"
                    [ngClass]="{ inactive: tableViewIsDefault }"
                    type="button"
                    class="btn legend-button"
                >
                    <cmps-icon
                        svgIcon="check-bold"
                        *ngIf="tableViewIsDefault === true"
                    ></cmps-icon>
                    <span class="cmps-cdk-mr-0dot5">{{
                        i18n._7509_DEFAULT_VIEW | translate
                    }}</span>
                </button>

                <!-- show legend -->
                <button
                    #legendButton
                    (click)="openLegendModal(legendPopup)"
                    type="button"
                    class="btn legend-button"
                    [ngClass]="{
                        'more-metrics-opened':
                            moreOAMetricsOpened === true ||
                            moreNonOAMetricsOpened === true
                    }"
                >
                    <cmps-icon svgIcon="format-list-bulleted-type"></cmps-icon>
                    <span class="cmps-cdk-mr-0dot5">{{
                        i18n._7391_LEGEND | translate
                    }}</span>
                </button>
            </div>
        </div>

        <div class="table-coaching-insight-content-sec">
            <table
                stickyTableContainer
                class="table coaching-insight-content"
                [ngClass]="{
                    'more-metrics-opened':
                        moreOAMetricsOpened === true ||
                        moreNonOAMetricsOpened === true
                }"
                [class.row-is-expanded]="rowExpanded === true"
            >
                <colgroup>
                    <ng-container
                        *ngFor="let th of columns | async; let i = index"
                    >
                        <col
                            [ngStyle]="th.colstyle"
                            *ngIf="th.active == true"
                        />
                    </ng-container>
                </colgroup>

                <thead>
                    <tr #thConatiner>
                        <ng-container
                            *ngFor="let th of columns | async; let i = index"
                        >
                            <ng-container *ngIf="i === 0">
                                <th
                                    scope="col"
                                    class="team-oa-header"
                                    stickyTableHeader
                                    [offsetHeight]="28"
                                    [ngStyle]="th.styles"
                                    [ngClass]="th.class"
                                >
                                    <!-- show/hide reporting performers -->
                                    <div
                                        *ngIf="
                                            activeView === ACTIVE_TAB_VIEW.TEAM
                                        "
                                        class="toggle-inactive-performers-absolute"
                                    >
                                        <div
                                            class="custom-control custom-control-inline custom-checkbox"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                [id]="_toggleActivePerformers"
                                                [checked]="
                                                    showInActivePerformers
                                                "
                                                (change)="
                                                    toggleShowActivePerformers(
                                                        $event
                                                    )
                                                "
                                                (click)="
                                                    $event.stopPropagation()
                                                "
                                            />
                                            <label
                                                class="custom-control-label"
                                                (click)="
                                                    $event.stopPropagation()
                                                "
                                                [for]="_toggleActivePerformers"
                                            >
                                                {{
                                                    i18n._7510_SHOW_PREVIOUS_DIRECT_REPORTS
                                                        | translate
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <cmps-team-view-tabs
                                        *ngIf="activeView != null"
                                        [activeView]="activeView"
                                        [selectedUser]="selectedUser"
                                        [othercount]="othercount"
                                        [teamcount]="teamcount"
                                        [self]="oaPeople?.self"
                                        (toggledTab)="builtFilter = false"
                                    ></cmps-team-view-tabs>
                                </th>
                            </ng-container>

                            <ng-container *ngIf="i !== 0">
                                <ng-container
                                    *ngIf="th.elastic === true; else nonElastic"
                                >
                                    <th
                                        scope="col"
                                        stickyTableHeader
                                        [offsetHeight]="28"
                                        elasticElement
                                        [dimensionIndex]="th.index"
                                        [ngStyle]="th.styles"
                                        class="team-oa-header"
                                        [ngClass]="th.class"
                                        *ngIf="th.active == true"
                                    >
                                        <div
                                            class="team-oa-header-item"
                                            [ngClass]="th.class"
                                        >
                                            <div
                                                class="header-content"
                                                [ngClass]="
                                                    th.headerContentClass
                                                "
                                            >
                                                <span>{{ th.header }}</span>
                                            </div>
                                            <div class="team-oa-header-icons">
                                                <ng-container
                                                    *ngFor="let icon of th.icon"
                                                >
                                                    <div
                                                        class="team-oa-header-icon-container"
                                                    >
                                                        <cmps-icon
                                                            class="cmps-cdk-cursor-pointer"
                                                            [svgIcon]="
                                                                icon.class[
                                                                    icon.counter
                                                                ]
                                                            "
                                                            [title]="
                                                                icon.title
                                                                    ? icon
                                                                          .title[
                                                                          icon
                                                                              .counter
                                                                      ]
                                                                    : ''
                                                            "
                                                            (click)="
                                                                toggle(
                                                                    $event,
                                                                    icon
                                                                )
                                                            "
                                                            *ngIf="
                                                                icon &&
                                                                icon.state !==
                                                                    undefined
                                                            "
                                                        ></cmps-icon>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </th>
                                </ng-container>

                                <ng-template #nonElastic>
                                    <th
                                        scope="col"
                                        stickyTableHeader
                                        [offsetHeight]="28"
                                        [ngStyle]="th.styles"
                                        class="team-oa-header"
                                        [ngClass]="th.class"
                                        *ngIf="th.active == true"
                                    >
                                        <div
                                            class="team-oa-header-item"
                                            [ngClass]="th.class"
                                        >
                                            <div
                                                class="header-content"
                                                [ngClass]="
                                                    th.headerContentClass
                                                "
                                            >
                                                <span>{{ th.header }}</span>
                                            </div>
                                            <ng-container
                                                *ngFor="let icon of th.icon"
                                            >
                                                <div
                                                    class="team-oa-header-icon-container"
                                                >
                                                    <cmps-icon
                                                        class="cmps-cdk-cursor-pointer"
                                                        [svgIcon]="
                                                            icon.class[
                                                                icon.counter
                                                            ]
                                                        "
                                                        [title]="
                                                            icon.title
                                                                ? icon.title[
                                                                      icon
                                                                          .counter
                                                                  ]
                                                                : ''
                                                        "
                                                        (click)="
                                                            toggle($event, icon)
                                                        "
                                                        *ngIf="
                                                            icon &&
                                                            icon.state !==
                                                                undefined
                                                        "
                                                    ></cmps-icon>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </th>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                    </tr>
                </thead>

                <ng-container [ngSwitch]="activeView">
                    <ng-container *ngSwitchCase="ACTIVE_TAB_VIEW.SELF">
                        <tbody
                            personList
                            class="coaching-insight-metrics-sec"
                            [people]="oaPeople.self"
                            [type]="'single'"
                            [columns]="columns"
                            [activeMetric]="activeMetric | async"
                            [activecolumns]="activecolumns | async"
                            [activeMember]="activeMember | async"
                            [activeView]="activeView"
                            [rowExpanded]="rowExpanded"
                            (rowExpandedChange)="rowExpanded = $event"
                            (openedWithNonKPIButton)="openNonKPI = $event"
                            (openedWithoutOpp)="setOpenWithoutOpp($event)"
                        ></tbody>
                    </ng-container>
                    <ng-container *ngSwitchCase="ACTIVE_TAB_VIEW.TEAM">
                        <tbody
                            personList
                            class="coaching-insight-metrics-sec"
                            [people]="oaPeople.team"
                            [type]="'multi'"
                            [columns]="columns"
                            [activeMetric]="activeMetric | async"
                            [activecolumns]="activecolumns | async"
                            [activeMember]="activeMember | async"
                            [activeView]="activeView"
                            [rowExpanded]="rowExpanded"
                            (rowExpandedChange)="rowExpanded = $event"
                            (openedWithoutOpp)="setOpenWithoutOpp($event)"
                        ></tbody>
                    </ng-container>
                    <ng-container *ngSwitchCase="ACTIVE_TAB_VIEW.OTHERS">
                        <tbody
                            personList
                            class="coaching-insight-metrics-sec"
                            [people]="oaPeople.others"
                            [type]="'multi'"
                            [columns]="columns"
                            [activeMetric]="activeMetric | async"
                            [activecolumns]="activecolumns | async"
                            [activeMember]="activeMember | async"
                            [activeView]="activeView"
                            [rowExpanded]="rowExpanded"
                            (rowExpandedChange)="rowExpanded = $event"
                            (openedWithoutOpp)="setOpenWithoutOpp($event)"
                        ></tbody>
                    </ng-container>
                </ng-container>
            </table>
        </div>
    </div>
</div>

<ng-template #legendPopup>
    <div class="cmps-cdk-bg-color-white cmps-cdk-min-w-512px legend-body">
        <div
            class="cmps-cdk-d-flex cmps-cdk-justify-content-flex-end cmps-cdk-p-0dot25"
        >
            <cmps-icon
                class="cmps-cdk-fill-grey-300 hover:cmps-cdk-fill-grey-400 cmps-cdk-cursor-pointer"
                svgIcon="close"
                (click)="_ref.close()"
            ></cmps-icon>
        </div>
        <div class="modal-body text-center">
            <oa-legend></oa-legend>
        </div>
    </div>
</ng-template>
